export const roboCallTaskStateWeb: { value: number; text: string }[] = [
  { value: 0, text: 'Не обработано' },
  { value: 1, text: 'Без результата' },
  { value: 2, text: 'Подтверждение' },
  { value: 3, text: 'Отмена' },
  { value: 4, text: 'Перенос' },
  { value: 5, text: 'Отказ от личности' },
];
